import { configureStore } from '@reduxjs/toolkit';
import { catalogosSlice } from './catalagos/slice';
import { usuarioSlice } from './usuarios/slice';
import { empleadosSlice } from './empleados/slice';
import { clientesSlice } from './clientes/slice';
import { equiposSlice } from './equipos/slice';
import { facturacionSlice } from './facturacion/slice';
import { ordenesSlice } from './ordenes/slice';
import { FinanzasSlice } from './finanzas/slice';
import { ReportSlice } from './reportes/slice';
import { salesSlice } from './sales/slice';
import { GarantiasSlice } from './garantias/slice';
import { cashOutSlice } from '../../layout/pages/finance/cashOut/store/slice';
import { newReportsSlice } from '../../layout/pages/reports/store/slice';
import { reportsFinanceSlice } from '../../layout/pages/finance/reports/store/slice';
import { inventario } from '../../layout/pages/inventory/app/store/Slice';
import { catalogs } from '../../layout/pages/inventory/app/store/catalogs/slice';
import { products } from '../../layout/pages/inventory/app/store/products/slice';
import { requests } from '../../layout/pages/inventory/app/store/requests/slice';
import { evidences } from '../../layout/pages/inventory/app/store/evidences/slice';
import { customerDetail } from '../../layout/pages/customers/layout/store/Slice';



export default configureStore({
  reducer: {
    usuario: usuarioSlice.reducer,
    empleados: empleadosSlice.reducer,
    clientes: clientesSlice.reducer,
    equipos: equiposSlice.reducer,
    facturacion: facturacionSlice.reducer,
    catalogos: catalogosSlice.reducer,
    finanzas: FinanzasSlice.reducer,
    reportes: ReportSlice.reducer,



    //Operativo
    ordenes: ordenesSlice.reducer,
    ventasPedido: salesSlice.reducer,
    garantias: GarantiasSlice.reducer,

    // Nuevos Modulos
    cashOut: cashOutSlice.reducer,
    newReports: newReportsSlice.reducer,

    // Nuevos Reportes
    reportsFinance: reportsFinanceSlice.reducer,

    // Inventario
    inventario: inventario.reducer,
    catalogs: catalogs.reducer,
    products: products.reducer,
    requests: requests.reducer,
    evidences: evidences.reducer,
    customerDetail: customerDetail.reducer,


  },
})